const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/u

export function serializeReservationCalendarDay(date: Date): string {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function formatReservationCalendarDay(date: string): string {
  const dateOnlyMatch = DATE_ONLY_PATTERN.exec(date)
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch
    return `${day}.${month}.${year}`
  }

  const parsed = new Date(date)
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString('pl-PL', { timeZone: 'Europe/Warsaw' })
  }

  return date
}
